/*
 * Grid layout component. Cells can contain other components.
 */

import React from 'react';

import Helpers from './helpers.jsx'

import GridLayout from './grid_layout.jsx'
import Resolver from '../component_resolver.jsx';

import { resolveComponentProps } from '../form_viewer.jsx';

export default class AdaliaMEExternalEntity extends GridLayout {

  static get TYPE() {
      return 'adalia_me_external_entity';
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
        rows: [
            [{span: 1, component: null}, {span: 1, component: null}]
        ]
    });
  }

  static dropComponent(dropArea, targetContent, droppedContent, components, isNested) {
    droppedContent.endpoint = targetContent.endpoint;
    return super.dropComponent(dropArea, targetContent, droppedContent, components, isNested);
  }

  renderView() {
    let rows = this.props.content.rows.map((row, rowIdx) => {
        let cols = row.map((col, colIdx) => {
            let component = null;

            if (col.component) {
                component = Resolver.createElement(col.component.type, 
                  resolveComponentProps(col.component, this.props, {
                    swapComponentsOnDrop: true, 
                    selectCallback: this.props.selectCallback, 
                    selectedId: this.props.selectedId,
                    deleteRepeatableRegionAnswerCallback: this.props.deleteRepeatableRegionAnswerCallback,
                    fieldScope: this.props.fieldScope,
                    repeatedFieldScope: this.props.repeatedFieldScope,
                    endpoint: this.props.content.endpoint
                  })
                );
            } else if (this.inEditMode) {
                component = (<Helpers.DropArea componentId={this.props.content.id} context={rowIdx + '-' + colIdx} />);
            }
            return (
                <div key={colIdx} className="grid-col" style={{flex: col.span}} data-flex={col.span}>
                    {component}
                </div>
            );
        });
        return (
            <div key={rowIdx} className="grid-row">
                {cols}
            </div>
        );
    });
    return (
        <div className="wrapper" data-endpoint={this.props.content.endpoint}>
            {rows}
        </div>
    );
  }


}
